<template>
  <div class="container">
    <custom-select
      label="Estado civl"
      :value="value"
      name="estadoCivil"
      @input="onChange"
      :items="estadosCiviles"
      :quantumObfuscate="quantumObfuscate"
    />
  </div>
</template>

<script>
import { estadosCiviles } from "@/config/constants/index";
import CustomSelect from "@/components/core/custom/CustomSelect";
export default {
  name: "CivilStatus",
  components: { CustomSelect },
  props: {
    value: String,
    quantumObfuscate: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    estadosCiviles() {
      return estadosCiviles;
    }
  },
  methods: {
    onChange(val) {
      this.$emit("input", val);
    }
  }
};
</script>
